import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";
import { isNonEmptyVariable } from "@/util/common_function";

// Fetch all clientParams for a group
export const fetchClientParams = createAsyncThunk(
  "clientParams/fetchAll",
  async (staffGroupsId = null) => {
    const { data } = await api.get(API_ENDPOINTS.config.clientParams.getAll);
    // filter by staffGroupsID
    if (isNonEmptyVariable(staffGroupsId)) {
      return data.filter((p) => p.staffGroupsID === staffGroupsId);
    } else {
      return data;
    }
  }
);

// Create or update
export const saveClientParam = createAsyncThunk(
  "clientParams/save",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.config.clientParams.createOrUpdate,
      payload
    );
    return data;
  }
);

// Delete
export const deleteClientParam = createAsyncThunk(
  "clientParams/delete",
  async (id) => {
    await api.delete(API_ENDPOINTS.config.clientParams.deleteClientParams + id);
    return id;
  }
);
